<!-- WCAG 4.1.3 — always mounted; NVDA often misses LiveAnnouncer alone (Deque #2167604). -->
<div
  role="status"
  aria-live="polite"
  aria-atomic="true"
  class="cdk-visually-hidden"
>
  {{ a11yStatusMessage }}
</div>
<div *ngIf="shouldShowPreloader" class="preloader-backdrop" aria-hidden="true">
  <div class="loader" aria-hidden="true"></div>
</div>
